<template>
  <div class="loginLoginBg" style="text-align:center;">
    <div class="loginMain">
      <div id="login" class="login bgfff">
        <div class="left">
          <!-- <img :src="leftImg?leftImg:loginImg" /> -->
          <img :src="leftImg" />
        </div>
        <div class="right" :style="syStyle">
          <div class="formBox">
            <h3>Welcome to login/register</h3>
            <a href=" https://reg.exporeg.cn/web/2024/CN/2403FIC/#/login?ExhID=6550" style="position: absolute; right: 20px; top: 20px;">中文</a>
            <div style="text-align: left;font-size: 14px;">
              <p>Tips:</p>
              <p>&nbsp;</p>
              <p>For registered audience, you can click on [Login] to access your confirmation letter.</p>
              <p style="margin-top: 10px;">For unregistered audience, please finish your online registration through [Register]</p>
            </div>
            <div
              style="text-align: left;font-size: 14px;"
              class="loginEx"
              v-html="LoginExplain"
            ></div>
            <el-tabs v-model="tabActive" class="tabsCon">
              <el-tab-pane label="账号密码登录" name="email" v-if="PwdLogin">
                <el-form :model="ruleForm2" ref="ruleForm" class="demo-ruleFormlogin">
                  <!-- 姓名 -->
                  <div class="div-inline">
                    <b>邮箱</b>
                    <el-input
                      class="div-inline-r"
                      name="email"
                      v-model="ruleForm2.email"
                      maxlength="50"
                      placeholder="请输入您的邮箱"
                      @blur="clearSpace('email')"
                    ></el-input>
                  </div>
                  <!-- 手机 -->
                  <div class="div-inline">
                    <b>密码</b>
                    <el-input
                      class="div-inline-r"
                      name="password"
                      @keyup.native="clearSpace('password')"
                      v-model="ruleForm2.password"
                      placeholder="请输入您的密码"
                    ></el-input>
                  </div>
                  <el-button
                    class="submit-btn"
                    type="primary"
                    :style="btnAllStyle"
                    :loading="showBtnLoading"
                    @click="login"
                  >登录</el-button>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="Email login" name="phone" v-if="CodeLogon">
                <el-form :model="ruleForm2" ref="ruleForm" class="demo-ruleFormlogin" @submit.native.prevent>
                  <!-- 手机 -->
                  <div class="div-inline">
                    <b>Email</b>
                    <el-input
                      class="div-inline-r"
                      name="email"
                      v-model="ruleForm2.email"
                      maxlength="50"
                      placeholder="Please enter your correct email address"
                      @blur="clearSpace('email')"
                    ></el-input>
                  </div>
                  <!-- <div class="div-inline">
                    <b>滑动验证</b>
                    <Verify ref="verifyLogin" @success="OK()" @error="ERR()" :type="3" :barSize="barSize"></Verify>
                  </div>
                  <div class="div-inline">
                    <b>短信验证码</b>
                    <div class="smsCode flex">
                      <div class="code-input">
                        <el-input
                          name="code"
                          @keyup.native="clearSpace('code')"
                          v-model="ruleForm2.code"
                          placeholder="请输入验证码"
                          maxlength="4"
                        ></el-input>
                      </div>
                      <el-button
                        class="count-down"
                        type="primary"
                        v-if="isDisabled"
                        :disabled="isRefresh"
                      >{{countDownNum}}s</el-button>
                      <el-button class="count-down" type="primary" v-else @click="OK()">获取验证码</el-button>
                    </div>
                  </div> -->
                  <el-button
                    class="submit-btn"
                    type="primary"
                    :style="btnAllStyle"
                    :loading="showBtnLoading"
                    @click="login"
                  >Login</el-button>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <div class="forgetPass" v-if="FindPwdSwitch"><span @click="findPassHandler">忘记密码</span></div>
            <div class="registerTypeChooseBtnBox"  style="text-align:right; padding-top:40px; font-size:12px;">
               Not registered yet?Please finish first
              <span
                v-if="RegistRegSwitch"
                style="color:#333; text-decoration: underline; cursor: pointer;"
                @click="toRegister()"
              >Register</span>
              <el-button
                v-if="GroupRegSwitch"
                class="type-btn"
                type="primary"
                :style="btnAllStyle"
                @click="toRegister()"
              >团组注册</el-button>
            </div>
          </div>
          <div class="llqTips">
            <Footer/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
import config from '../config'
import utils from '../utils'
import regExp from '../utils/regExp.js'
import Footer from '../components/Footer'
import Verify from 'vue2-verify'
import loginImg from '../../static/img/login-img.jpg'
import sybg from '../../static/img/sybg.png'
export default {
  name: 'Login',
  components: {
    Footer,
    Verify
  },
  data() {
    return {
      loginImg: loginImg,
      userMsg: {
        name: '',
        mobile: ''
      },
      barSize: {
        width: '358px',
        height: '40px'
      },
      switerIndex: 20,
      newSwiterIndex: 0,
      maxSwiterIndex: 300,
      bannerImg: '',
      leftImg: '',
      exhName: '', // 展会名字
      showBtnLoading: false, // load btn
      LoginExplain: '',
      LoginFont: '<p>-已注册的观众，可通过[登录/注册]直接进入确认函</p><p>-未注册的观众，可通过[登录/注册]完成在线注册</p>', // 提示信息
      isDisabled: false, // 是否发送验证码
      isInputCode: false, // 是否可以输入验证码
      isRefresh: true,
      countDownNum: 59, // 倒计时
      ImgCodeUrl: '',
      ruleForm2: {
        email: '',
        password: '',
        iphone: '',
        code: ''
      },
      ExhID: '', // 展会id
      slideVS: false, // 是否已滑动验证
      sybg: sybg,
      syStyle: {},
      tabActive: 'email',
      PwdLogin: true,
      CodeLogon: true,
      GroupRegSwitch: true,
      FindPwdSwitch: true,
      RegistRegSwitch: true,
      SmsSign: '昆仑亿发',
      btnAllStyle: {} // 按钮样式
    }
  },
  watch: {
    switerIndex: function() {
      var moveX = this.switerIndex - this.newSwiterIndex
      this.jigsaw = this.jigsaw + moveX
      this.newSwiterIndex = this.switerIndex
    }
  },
  mounted() {
    sessionStorage.clear() // 清空数据
    // 获取展会id
    this.ExhID = utils.getUrlParam().ExhID
      ? utils.getUrlParam().ExhID
      : config.exhID
    // 缓存展会id
    sessionStorage.setItem('ExhID', this.ExhID)
    var urlParam = utils.getUrlParam() // 获取url参数
    // 邀请者ID
    if (urlParam.InviteID && urlParam.InviteID !== 'undefined') {
      sessionStorage.setItem('InviteID', urlParam.InviteID)
    }
    // 邀请类型
    if (urlParam.InviteType && urlParam.InviteType !== 'undefined') {
      sessionStorage.setItem('InviteType', urlParam.InviteType)
    }
    // 邀请code
    if (urlParam.InviteCode && urlParam.InviteCode !== 'undefined') {
      sessionStorage.setItem('InviteCode', urlParam.InviteCode)
    }

    this.loadTothen() // token
    this.loadGlobPageConfig()
    this.loadPageConfig()
    var obj = sessionStorage.getItem('cacheLogin')
    if (obj) {
      this.ruleForm2 = JSON.parse(obj)
    }
    let params = new FormData();
        params.append('grant_type', 'client_credentials')
        params.append('client_secret', 'sptjj69BHUy4iriaf0BHU')
        params.append('client_id', 'shipintianjiaji')
    api.token(params).then(res => {
      console.log(res.data.access_token)
      sessionStorage.setItem('TMToken', res.data.access_token)
    });
  },
  methods: {
    findPassHandler() {
      this.$router.push({
        path: 'findPass',
        query: { ExhID: this.ExhID }
      })
    },
    login() {
      var param = {}
      // if (this.tabActive === 'email') {
        // 如果是邮箱登录
        if (this.ruleForm2.email === '') {
          this.$alert('Please enter your correct email address');
          return;
        }else if(!regExp.regCheckEmail.test(this.ruleForm2.email)) {
          this.$alert('Email format error please reenter');
          return;
        }
        param = {
          exhid: this.ExhID,
          UserName: this.ruleForm2.email,
          UserPwd: this.ruleForm2.password,
          LoginType: 2
        }
      // }else{
      //   if(this.ruleForm2.iphone === '') {
      //     this.$alert('请输入您的手机号');
      //     return;
      //   }else if(!regExp.regCheckCnMobile.test(this.ruleForm2.iphone)) {
      //     this.$alert('请正确输入您的手机号');
      //     return;
      //   }
      //   if(this.ruleForm2.code === '') {
      //     this.$alert('请输入您的验证码');
      //     document.getElementsByName('code')[0].focus();
      //     return;
      //   }
      //   param = {
      //     exhid: this.ExhID,
      //     UserName: this.ruleForm2.iphone,
      //     UserPwd: this.ruleForm2.code,
      //     LoginType: 1
      //   }
      // }
      this.showBtnLoading = true
      let _this = this
      api.login(param).then(res => {
        if(res.data.status === 'OK') {
          sessionStorage.setItem('PsjID', res.data.PsjID);
          this.$store.commit('setUserID', res.data.PsjID)
          sessionStorage.setItem('isLogin', true)
          this.$router.push({
            path: 'confirmation',
            query: { ExhID: this.ExhID }
          })
        }else{
          _this.$alert(res.data.ErrorEMsg);
          _this.showBtnLoading = false
        }
      })
    },
    toRegister() {
      this.$router.push({path: '/register', query: {ExhID: sessionStorage.getItem('ExhID')}})
    },
    regErr () {
      this.$refs.verifyLogin.refresh();
      sessionStorage.removeItem('token'); // 获取验证码失败，删除session存储的token
      this.slideCode = false; // 将是否滑动状态恢复到初始状态
    },
    OK () {
      var obj = this.ruleForm2;
      if (!regExp.notEmpty.test(obj.email)) {
        this.$alert('Please enter your correct email address');
        document.getElementsByName('email')[0].focus();
        this.regErr()
        return ''
      }else if (!regExp.regCheckEmail.test(obj.email)) {
        this.$alert('Email format error please reenter');
        document.getElementsByName('email')[0].focus();
        this.regErr()
        return ''
      }
      this.slideVS = true
      let _this = this
      _this.getJigsawCode(function(res) {
        sessionStorage.setItem('cacheAdress', JSON.stringify(res.data));
        _this.countDown();
        _this.isInputCode = _this.isDisabled = true;
      });
    },
    ERR () {
      console.log(444)
    },
    cacheInput: function(v, e) {
      var obj = this.ruleForm2
      sessionStorage.setItem('cacheLogin', JSON.stringify(obj))
    },
    onlyNumber: function(v) {
      var obj = this.ruleForm2
      var str = obj[v]
      obj[v] = str.replace(/\D/g, '')
      this.ruleForm2 = obj
    },
    loadTothen: function() {
      api.getEFWapToken({}).then(res => {
        if (res.data.status === 'OK') {
          sessionStorage.setItem('token', res.data.WapToken)
        } else {
          this.$alert(res.data.ErrorEMsg, 'Tips')
        }
      })
    },
    loadPageConfig: function() {
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'Login',
        Language: 'cn'
      }
      api.getPage(param).then(res => {
        // 首页配置
        if (res.data.status === 'OK') {
          var imgs = res.data.images
          var infos = res.data.promptinfo
          var sInfos = res.data.switchInfos
          for (let i = 0; i < infos.length; i++) {
            switch(infos[i].name) {
              case 'LoginExhName': // 展会名称
                this.exhName = infos[i].value
                // sessionStorage.setItem('titleStr', exhName) // 设置title值
                sessionStorage.setItem('titleStr', 'Food Ingredients China 2024') // 设置title值
                utils.setTitle()
                break;
              case 'LoginFont': // 温馨提示
                this.LoginFont = infos[i].value
                sessionStorage.setItem('LoginFont', this.LoginFont)
                break;
              case 'LoginBrowse': // 浏览器建议提示语
                sessionStorage.setItem('LoginBrowse', infos[i].value)
                break;
              case 'LoginExplain': // 港澳台说明文字
                this.LoginExplain = infos[i].value
                sessionStorage.setItem('LoginExplain', infos[i].value)
                break;
              case 'ClosedTip': // 闭展提示语
                sessionStorage.setItem('ClosedTip', infos[i].value)
                break;
            }
          }
          for (let i = 0; i < imgs.length; i++) {
            switch (imgs[i].name) {
              case 'LoginPagePic':
                this.leftImg = imgs[i].data[0] // 左侧图片
                sessionStorage.setItem('leftImg', this.leftImg)
                break;
              case 'ImgCodeUrl':
                this.ImgCodeUrl = imgs[i].data[0] // 滑动验证拼图
                break;
            }
          }
          this.leftImg = this.leftImg || this.loginImg
          for (let i = 0; i < sInfos.length; i++) {
            let obj = sInfos[i]
            switch (obj.name) {
              case 'IsClosed':
                if (obj.data) {
                  this.$router.push({
                    path: '/close',
                    query: { ExhID: this.ExhID }
                  })
                }
                break;
              case 'PwdLogin':
                this.PwdLogin = false // obj.data // 是否启用账号密码登录
                break;
              case 'CodeLogon':
                this.CodeLogon = obj.data // 是否启用手机号登录
                break;
              case 'GroupRegSwitch':
                this.GroupRegSwitch = obj.data // 是否启用团组注册
                break;
              case 'RegistRegSwitch':
                this.RegistRegSwitch = obj.data // 是否启用个人注册
                break;
              case 'FindPwdSwitch':
                this.FindPwdSwitch = false // obj.data // 是否启用找回密码
                break;
            }
          }
          // 切换账号密码登录/手机号登录
          // 如果只有验证码登录
          if (!this.PwdLogin && this.CodeLogon) {
            this.tabActive = 'phone'
          } else { // 如果两种登录方式都有或只有密码登录
            this.tabActive = 'email'
          }
        } else {
          this.$alert(res.data.ErrorEMsg)
        }
      })
    },
    loadGlobPageConfig: function() {
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'Global',
        Language: 'cn'
      }
      api.getPage(param).then(res => {
        if (res.data.status === 'OK') {
          var imgs = res.data.images
          var infos = res.data.promptinfo
          for (let i = 0; i < imgs.length; i++) {
            switch(imgs[i].name) {
              case 'OverallBanner': // banner图
                this.bannerImg = imgs[i].data[0]
                sessionStorage.setItem('bannerImg', this.bannerImg)
                break;
              case 'WatermarkBanner': // 水印图片
                if(imgs[i].data[0]) {
                  this.WatermarkBanner = imgs[i].data[0]
                  this.syStyle = {'background': 'url(' + this.WatermarkBanner + ') repeat center center'}
                  sessionStorage.setItem('syStyle', JSON.stringify(this.syStyle))
                }
                break;
              case 'StepImg': // 步骤图
                sessionStorage.setItem('stepImg', JSON.stringify(imgs[i].data))
                break;
            }
          }
          for (let i = 0; i < infos.length; i++) {
            switch(infos[i].name) {
              case 'LoginExhName':
                this.exhName = infos[i].value // 展会名称
                break;
              case 'SmsSign': // 短信签名
                this.SmsSign = infos[i].value
                sessionStorage.setItem('SmsSign', infos[i].value)
                break;
            }
          }
          res.data.SuccessInfos.map(item => {
            if(item.name === 'BaseSetting') {
              item.items.map(item2 => {
                switch(item2.title) {
                  case 'isConsistencyIdCard': // 是否开启实名验证
                    sessionStorage.setItem('isConsistencyIdCard', item2.text)
                    break;
                  case 'consistencyIdCardAppCode': // 实名验证code
                    sessionStorage.setItem('consistencyIdCardAppCode', item2.text)
                    break;
                  case 'IsRegistActivity': // 是否开启会议功能
                    sessionStorage.setItem('IsRegistActivity', item2.text)
                    break;
                  case 'themeColor': // 主题色
                    sessionStorage.setItem('themeColor', item2.text)
                    // 主题色
                    let root = document.querySelector(':root')
                    root.style.setProperty('--themeColor', item2.text);
                    break;
                  case 'IsEnableHelpRegist': // 是否启用协助注册
                    sessionStorage.setItem('IsEnableHelpRegist', item2.text)
                    break;
                  case 'IsEnableGroupRegist': // 是否启用团组注册
                    sessionStorage.setItem('IsEnableGroupRegist', item2.text)
                    break;
                  case 'IsEnableInviteRegist': // 是否启用邀请注册
                    sessionStorage.setItem('IsEnableInviteRegist', item2.text)
                    break;
                  case 'BottomImg': // 全局底部广告图
                    sessionStorage.setItem('BottomImg', item2.text)
                    break;
                  case 'IsEditePhoto': // 是否允许修改头像
                    sessionStorage.setItem('IsEditePhoto', item2.text)
                    break;
                  case 'PhotoModel': // 是否开启头像模式
                    sessionStorage.setItem('PhotoModel', item2.text)
                    break;
                  case 'isFaceRepat': // 头像是否查重
                    sessionStorage.setItem('isFaceRepat', item2.text)
                    break;
                  case 'IsRequiredPhoto': // 是否可以跳过拍头像
                    sessionStorage.setItem('IsRequiredPhoto', item2.text)
                    break;
                  case 'isCheckIDCard': // 是否身份证查重
                    sessionStorage.setItem('isCheckIDCard', item2.text)
                    break;
                }
              })
            }
          })
          // 全局按钮
          for (let t = 0; t < res.data.buttons.length; t++) {
            let tmpObj = res.data.buttons[t]
            switch(tmpObj.OverallButton) {
              case 'Globalbutton':
                sessionStorage.setItem('btnAll', JSON.stringify(tmpObj))
                this.btnAllStyle = tmpObj.styles
                break;
            }
          }
        } else {
          this.$alert(res.data.ErrorEMsg)
        }
      })
    },
    getJigsawCode: function(cb) {
      if (!this.ExhID) {
        this.$alert('缺失了展馆ID')
      }
      api.getVerifyToken({
        WapToken: sessionStorage.getItem('token'),
        ExhID: this.ExhID
      }).then(res2 => {
        // 获取短信验证码
        if (res2.data.status === 'OK') {
          var param = {
            ExhID: this.ExhID,
            sign: this.SmsSign,
            RegistType: 'pc',
            NotUseCache: 'yes',
            mobile: this.ruleForm2.iphone,
            openid: '',
            imgcode: '',
            token: res2.data.token,
            type: '',
            WapToken: sessionStorage.getItem('token')
          }
          api.getVerificationCode(param).then(res => {
            if (res.data.status === 'OK') {
              if (cb) {
                cb(res)
              }
            } else {
              this.$alert(res.data.ErrorEMsg, 'Tips')
              this.$refs.verifyLogin.refresh();
            }
          })
        } else {
          this.$alert(res2.data.ErrorEMsg, 'Tips')
          this.$refs.verifyLogin.refresh();
        }
      })
    },
    clearSpace: function(n) {
      // 清楚空格
      var obj = this.ruleForm2
      if (n === 'email') {
        obj[n] = obj[n].trim()
      } else if (n === 'iphone' || n === 'code') {
        obj[n] = obj[n].replace(/\D/g, '')
      } else {
        obj[n] = obj[n].replace(/\s+/gim, '')
      }
      this.ruleForm2 = obj
      this.cacheInput()
      return false
    },
    countDown: function() {
      // 倒计时
      let _this = this
      var num = 59
      var stop = setInterval(() => {
        num--
        if (num < 0) {
          clearInterval(stop) //
          _this.$refs.verifyLogin.refresh();
        } else {
          _this.countDownNum = num
        }
      }, 1000)
    }
  }
}
</script>

<style>
.forgetPass{
  text-align: right;
  padding-top: 15px;
  font-size: 12px;
}
.forgetPass span{
  text-decoration: underline;
}
.registerTypeChooseBtnBox{
  /* display: flex; */
  width: 100%;
  justify-content: space-between;
  padding: 18px 0;
}
.tabsCon{
  padding-top: 20px;
}
.type-btn, .type-btn:hover{
  display: inline-block !important;
  flex:1;
  color:#fff !important;
}
.loginBg{
  background: url('../../static/img/loginBg.jpg') no-repeat center center;
  background-size: cover;
}
.login{
  margin: 0px auto;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  display: flex;
}
.loginMain{
  width: auto;
  display: inline-block;
  margin: 0px auto;
  padding: 60px 0 60px 0;
}
.login .left {
  /* float: right; */
  /* width: 40%; */
  /* position: absolute;
  left: 0;
  top: 0;
  height: 100%; */
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.left img {
  /* height: 100%; */
  height: 650px;
  border-right: 1px solid #eee;
  margin: 0 auto;
}
.login .right{
  /* float: right; */
  width: 480px;
  height: inherit;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 30px 0 0;
  position: relative;
}
.right .formBox {
  padding: 30px 60px 0;
}
.left h3 {
  font-weight: normal;
  padding-bottom: 55px;
  font-size: 20px;
}
.right h3{
  text-align: left;
  padding-bottom: 50px;
  font-size: 20px;
  font-weight: 600;
}
.div-inline b{
  font-weight: normal;
  font-size: 12px;
  padding: 0;
  line-height: 30px;
  width: 100%;
  text-align: left;
  display: inline-block;
}
.div-inline{
  align-items: center;
}
.demo-ruleFormlogin .el-input{
  width:100%;
  margin:0;
}
.verify-btn{
  display: none;
}
.smsCode{
  border:1px solid #DCDFE6;
  border-radius: 4px;
}
.smsCode .code-input{
  flex: 1;
}
.smsCode .code-input .el-input__inner{
  border:0;
}
.count-down,
.smsCode .el-button--primary,
.smsCode .el-button--primary:hover,
.smsCode .el-button--primary:focus,
.smsCode .el-button--primary:active{
  height:40px;
  margin-left: 15px;
  background: transparent !important;
  color: var(--themeColor) !important;
  border: 0;
  width: 120px;
  text-align: center;
  padding:0;
  height: 42px;
  line-height: 42px;
  flex: none;
}
.llqTips {
  padding: 0 20px;
  position: absolute;
  left: 40px;
  bottom: 10px;
}
/*滑块 sss*/
.switer-box {
  width: 300px;
  height: 30px;
  margin: 10px auto;
}
#login .el-slider__button {
  width: 40px;
  height: 30px;
  border-radius: 0;
}
#login .el-slider__bar {
  height: 30px;
}
.el-slider__runway {
  height: 30px;
}
#login .el-slider__button-wrapper {
  top: 0;
}
/*滑块 eee*/
.switer-img {
  width: 300px;
  height: 150px;
  margin: 10px autp;
}
.canvas-box {
  width: 300px;
  height: 150px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.canvas-box .canvas {
  position: absolute;
  left: 0;
  top: 0;
}
.row-bg {
  background: #fff;
  min-height: calc(100vh);
  overflow: hidden;
}
.row-bg img {
  /* max-width: 300px; */
  margin: 0 auto;
}
.row-bg p {
  text-align: center;
  color: #424242;
  font-size: 14px;
}
.row-bg .right {
  float: right;
  width: 60%;
  box-sizing: border-box;
  padding: 30px 0;
}
.demo-ruleFormlogin{
  width: 100%;
  margin:0px auto;
}
.holder {
  height: 230px;
}
.com-name {
  text-align: center;
  font-size: 20px;
  color: #424242;
  width: 80%;
  margin: 20px auto 40px;
}
.code-input {
  width: 50%;
  min-width: 150px;
}
.el-form-item__content {
  margin-left: 0 !important;
}
#login .el-slider__runway {
  text-align: center;
  color: #c7c7c7;
  font-size: 14px;
  line-height: 30px;
  height: 30px;
}
.el-slider__runway:after {
  content: '向右滑动完成拼图获取验证码...';
  color: red;
}
#login .el-slider__button-wrapper::after {
  content: '→';
  position: absolute;
  left: 7px;
  top: 0;
  font-size: 28px;
  color: #17202e;
  line-height: 1;
}
.submit-btn, .submit-btn:hover{
  display: block !important;
  width:100% !important;
  margin:0 auto !important;
  margin-top:30px !important;
  color:#fff !important;
}
.flex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
}
.count-down {
  height: 40px;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue